import { Badge } from '@/components/ui/badge';

const TONE = { match: 'bg-emerald-100 text-emerald-800', mismatch: 'bg-rose-100 text-rose-800', review: 'bg-amber-100 text-amber-800', unknown: 'bg-muted text-muted-foreground' };
const LABEL = { match: 'Match', mismatch: 'Mismatch', review: 'Review', unknown: 'Not verified' };
const BOX = { green: 'border-emerald-300 bg-emerald-50', red: 'border-rose-300 bg-rose-50', amber: 'border-amber-300 bg-amber-50', muted: 'border-border bg-muted/40' };

export const VerificationResult = ({ rows, verdict, parsed }) => (
  <div className="space-y-3" data-testid="piv-result">
    <div className={`rounded-lg border p-3 ${BOX[verdict.tone]}`} data-testid={`piv-verdict-${verdict.key}`}>
      <p className="font-semibold text-sm">{verdict.label}</p>
      <p className="text-xs mt-1">{verdict.text}</p>
    </div>
    {rows.length > 0 && (
      <div className="overflow-x-auto"><table className="w-full text-xs min-w-[480px]" data-testid="piv-compare-table">
        <thead><tr className="text-left text-muted-foreground"><th className="py-1">Check</th><th>From QR</th><th>Purchase record</th><th>Result</th></tr></thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.label} className="border-t border-border align-top" data-testid={`piv-row-${r.label.toLowerCase().replace(/\W+/g, '-')}`}>
              <td className="py-1.5 font-medium">{r.label}{r.note && <div className="text-[10px] text-muted-foreground font-normal">{r.note}</div>}</td>
              <td dir="auto">{String(r.qr)}</td><td dir="auto">{String(r.bill)}</td>
              <td><Badge className={`${TONE[r.status]} border-0`}>{LABEL[r.status]}</Badge></td>
            </tr>
          ))}
        </tbody>
      </table></div>
    )}
    <ul className="text-[11px] text-muted-foreground list-disc pl-4 space-y-0.5" data-testid="piv-limits">
      <li>Supplier VAT registration: <b>not verified here</b> — use “Verify Supplier VAT” on ZATCA.</li>
      <li>ZATCA clearance/reporting: <b>not confirmed</b> — only ZATCA’s own invoice verification service is authoritative.</li>
      {parsed?.ok && (parsed.fields.invoice_hash || parsed.fields.crypto_signature)
        ? <li>QR contains a Phase 2 cryptographic stamp; its signature is not checked by this tool.</li>
        : parsed?.ok && <li>QR has only basic (Phase 1) fields — common for older or simplified invoices; not by itself a sign of a fake invoice.</li>}
      <li>Nothing is saved; bills, VAT and accounts are not changed.</li>
      <li>A matching QR is not proof that a supplier invoice is genuine — anyone can generate a QR with matching numbers.</li>
    </ul>
  </div>
);
